// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import { CastReceiverContext } from 'chromecast-caf-receiver/cast.framework';
import { fromEmitter } from 'rxjs-from-emitter';
import { filter, skip, skipUntil, startWith, switchMap, takeUntil } from 'rxjs/operators';
// eslint-disable-next-line monorepo-dependencies/no-unlisted-package-import
import { MediaElementEvent } from 'chromecast-caf-receiver/cast.framework.events';
import cast from '../../types/chromecast-caf-receiver/index';
import { bootstrapAction } from '../extensions';

export class StallCheckerPlugin {
  init() {
    bootstrapAction.register(this.bootstrap.bind(this));
  }

  async bootstrap(context: CastReceiverContext) {
    const playerManager = context.getPlayerManager();
    // if no "CAN PLAY" is present after 3 tries, force a pause/play
    fromEmitter(playerManager)
      .event('CLIP_ENDED')
      .pipe(
        startWith(null),
        switchMap(() => {
          const progress$ = fromEmitter(playerManager)
            .event(cast.framework.events.EventType.PROGRESS)
            .pipe(
              skip(3),
              filter((e: MediaElementEvent) => e.currentMediaTime === 0)
            );
          const segmentDownloaded$ = fromEmitter(playerManager).event(
            cast.framework.events.EventType.SEGMENT_DOWNLOADED
          );
          const canPlay$ = fromEmitter(playerManager).event(
            cast.framework.events.EventType.CAN_PLAY
          );

          return progress$.pipe(skipUntil(segmentDownloaded$), takeUntil(canPlay$));
        })
      )
      .subscribe(() => {
        playerManager.pause();
        playerManager.play();
      });
  }
}
